import React, { PropsWithChildren } from 'react';

import { Box, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

type Props = PropsWithChildren<{
  id: string;
  title: string;
}>;

export default function UserDetailsFormSection({ id, title, children }: Props) {
  const sectionId = `user-details-${id}`;

  return (
    <Paper
      component="section"
      variant="outlined"
      id={sectionId}
      aria-labelledby={`${sectionId}-title`}
      sx={{
        px: { xs: 2, lg: 3 },
        pb: { xs: 2, lg: 3 },
        pt: 2,
        scrollMarginTop: 24,
        borderRadius: 2,
        backgroundImage: (theme) =>
          `linear-gradient(${alpha(theme.palette.primary.main, 0.025)}, ${alpha(theme.palette.primary.main, 0.025)})`,
        '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' },
      }}
    >
      <PageSubheader
        showDivider={false}
        sx={{ pt: 0, pb: 1.5 }}
        title={
          <Box component="span" id={`${sectionId}-title`} sx={{ typography: 'h4', fontWeight: 600 }}>
            {title}
          </Box>
        }
      />
      {children}
    </Paper>
  );
}
